import { useLayoutEffect, useRef, useState } from "react";
import { LuBarChart3, LuFileText, LuStore, LuUsers } from "react-icons/lu";
import { FiUsers } from "react-icons/fi";

export const REPORT_TABS = [
    { id: "statistics", label: "Statistikat", icon: LuBarChart3 },
    { id: "users", label: "Përdoruesit", icon: FiUsers },
    { id: "receipts", label: "Kuponat", icon: LuFileText },
    { id: "winners", label: "Fituesit", icon: LuUsers },
    { id: "business_winners", label: "Fituesit (biznese)", icon: LuStore },
];

export default function ReportsTabs({ value, onChange }) {
    const listRef = useRef(null);
    const btnRefs = useRef({});
    const [indicator, setIndicator] = useState({ left: 0, width: 0, ready: false });

    useLayoutEffect(() => {
        const updateIndicator = () => {
            const activeBtn = btnRefs.current[value];
            if (!activeBtn) return;
            setIndicator({
                left: activeBtn.offsetLeft,
                width: activeBtn.offsetWidth,
                ready: true,
            });
        };

        updateIndicator();

        const ro = new ResizeObserver(updateIndicator);
        if (listRef.current) ro.observe(listRef.current);
        window.addEventListener("resize", updateIndicator);
        return () => {
            ro.disconnect();
            window.removeEventListener("resize", updateIndicator);
        };
    }, [value]);

    return (
        <div className="rounded-2xl border border-gray-200/80 bg-white p-1.5 shadow-[0_1px_2px_rgba(0,0,0,0.04)] w-full overflow-x-auto scrollbar-thin">
            <div ref={listRef} className="relative inline-flex w-full min-w-max">
                {/* Sliding active-tab indicator */}
                <span
                    aria-hidden="true"
                    className={`absolute top-0 bottom-0 rounded-xl bg-secondary shadow-sm transition-[transform,width] duration-300 ease-out ${
                        indicator.ready ? "opacity-100" : "opacity-0"
                    }`}
                    style={{
                        transform: `translateX(${indicator.left}px)`,
                        width: indicator.width,
                    }}
                />
                {REPORT_TABS.map((tab) => {
                    const Icon = tab.icon;
                    const isActive = tab.id === value;
                    return (
                        <button
                            key={tab.id}
                            ref={(el) => (btnRefs.current[tab.id] = el)}
                            type="button"
                            onClick={() => onChange(tab.id)}
                            className={`relative z-[0] flex-1 min-w-max inline-flex items-center justify-center gap-2 px-4 h-10 rounded-xl text-sm font-semibold transition-colors whitespace-nowrap ${
                                isActive
                                    ? "text-white"
                                    : "text-gray-600 hover:text-gray-900"
                            }`}
                        >
                            <Icon size={16} />
                            {tab.label}
                        </button>
                    );
                })}
            </div>
        </div>
    );
}
